module.exports = __webpack_public_path__ + "static/media/zbths-2004.27081b57.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentations/modern-javascript/assets/zbths-2004.png
// module id = 1538
// module chunks = 0